import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ROUTES } from '@/shared/config/constants';
import { ProtectedRoute } from './ProtectedRoute';
import { GuestRoute } from './GuestRoute';
import { AuthenticatedLayout } from './AuthenticatedLayout';
import LoginPage from '@/pages/LoginPage/LoginPage';
import OtpPage from '@/pages/OtpPage/OtpPage';
import ForbiddenPage from '@/pages/ForbiddenPage/ForbiddenPage';
import DeploymentsPage from '@/pages/DeploymentsPage/DeploymentsPage';
import LiveModePage from '@/pages/LiveModePage/LiveModePage';
import DeploymentOverviewPage from '@/pages/DeploymentOverviewPage/DeploymentOverviewPage';
import DeploymentDashboardPage from '@/pages/DeploymentDashboardPage/DeploymentDashboardPage';
import DeploymentRecommendationsPage from '@/pages/DeploymentRecommendationsPage/DeploymentRecommendationsPage';
import DeploymentAlertsPage from '@/pages/DeploymentAlertsPage/DeploymentAlertsPage';
import DeploymentSettingsPage from '@/pages/DeploymentSettingsPage/DeploymentSettingsPage';
import DeploymentSimulationPage from '@/pages/DeploymentSimulationPage/DeploymentSimulationPage';
import UsersPage from '@/pages/UsersPage/UsersPage';
import GlobalSettingsPage from '@/pages/GlobalSettingsPage/GlobalSettingsPage';
import ProfileEditPage from '@/pages/ProfileEditPage/ProfileEditPage';
import ErrorPage from '@/pages/ErrorPage/ErrorPage';

export const router = createBrowserRouter([
  { path: ROUTES.LOGIN, element: <GuestRoute><LoginPage /></GuestRoute>, errorElement: <ErrorPage /> },
  { path: ROUTES.OTP, element: <GuestRoute><OtpPage /></GuestRoute>, errorElement: <ErrorPage /> },
  { path: ROUTES.FORBIDDEN, element: <ForbiddenPage /> },
  {
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      { path: ROUTES.DEPLOYMENTS, element: <DeploymentsPage /> },
      { path: ROUTES.DEPLOYMENT_LIVE, element: <LiveModePage variant="recommended" /> },
      { path: ROUTES.DEPLOYMENT_LIVE_TERMINAL, element: <LiveModePage variant="terminal" /> },
      { path: ROUTES.DEPLOYMENT_LIVE_CONSENSUS, element: <LiveModePage variant="consensus" /> },
      { path: ROUTES.DEPLOYMENT_LIVE_BROADCAST, element: <LiveModePage variant="broadcast" /> },
      { path: ROUTES.DEPLOYMENT_LIVE_HUD, element: <LiveModePage variant="hud" /> },
      { path: ROUTES.DEPLOYMENT_LIVE_BOARD, element: <LiveModePage variant="board" /> },
      { path: ROUTES.DEPLOYMENT_OVERVIEW, element: <DeploymentOverviewPage /> },
      { path: ROUTES.DEPLOYMENT_DASHBOARD, element: <DeploymentDashboardPage /> },
      { path: ROUTES.DEPLOYMENT_RECOMMENDATIONS, element: <DeploymentRecommendationsPage /> },
      { path: ROUTES.DEPLOYMENT_ALERTS, element: <DeploymentAlertsPage /> },
      { path: ROUTES.DEPLOYMENT_SETTINGS, element: <DeploymentSettingsPage /> },
      { path: ROUTES.DEPLOYMENT_SIMULATION, element: <DeploymentSimulationPage /> },
      { path: ROUTES.USERS, element: <UsersPage /> },
      { path: ROUTES.SETTINGS, element: <GlobalSettingsPage /> },
      { path: ROUTES.PROFILE_EDIT, element: <ProfileEditPage /> },
    ],
  },
  { path: '/', element: <Navigate to={ROUTES.DEPLOYMENTS} replace /> },
  { path: '*', element: <Navigate to={ROUTES.DEPLOYMENTS} replace /> },
]);
